import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ManualOrderService } from 'src/app/core/services/api-services/manual-order.service';

@Component({
  selector: 'app-add-insurance-modal',
  templateUrl: './add-insurance-modal.component.html',
  styleUrls: ['./add-insurance-modal.component.scss'],
})
export class AddInsuranceModalComponent implements OnInit {
  insuranceForm: FormGroup | any;
  userId: any;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AddInsuranceModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public toastrService: ToastrService,
    private manualService: ManualOrderService // Inject UserService here
  ) {
    this.userId = this.data.userId;
    //console.log('Received patient ID:', this.userId);
  }

  ngOnInit(): void {
    this.initializeNote();
  }

  initializeNote() {
    this.insuranceForm = this.fb.group({
      user_id: [this.userId],
      insurance_provider: [''],

      card_holder: [''],
      contract_plan_number: [''],

      career_number: [''],
      memberId: [''],
      front: [''],
      back: [''],
    });
  }

  // Function to handle file change event for front image
  handleFrontImage(event: any) {
    const file = event.target.files[0];
    //console.log('Front image file:', file); // Debugging statement
    if (file && file.type.startsWith('image/')) {
      // Check if it's an image file
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result as string;
        //console.log(base64String);

        this.insuranceForm.get('front').setValue(base64String);
      };
      reader.onerror = (error) => {
        console.error('Error converting front image to base64:', error);
      };
      reader.readAsDataURL(file); // Convert image to base64
    } else {
      console.error('Selected file is not an image.');
    }
  }

  // Function to handle file change event for back image
  handleBackImage(event: any) {
    const file = event.target.files[0];
    //console.log('Back image file:', file); // Debugging statement
    if (file && file.type.startsWith('image/')) {
      // Check if it's an image file
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result as string;
        this.insuranceForm.get('back').setValue(base64String);
      };
      reader.onerror = (error) => {
        console.error('Error converting back image to base64:', error);
      };
      reader.readAsDataURL(file); // Convert image to base64
    } else {
      console.error('Selected file is not an image.');
    }
  }

  // Function to convert image to base64
  convertImageToBase64(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result as string);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }

  onFrontFileChange(event: any): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    try {
      this.insuranceForm.patchValue({
        front: file,
      });
    } catch (err) {
      console.log(' error ' + err);
    }
  }


  onBackFileChange(event: any): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    try {
      this.insuranceForm.patchValue({
        back: file,
      });
    } catch (err) {
      console.log(' error ' + err);
    }
  }

  submitForm() {
    if (this.insuranceForm.valid) {

      if(!this.insuranceForm.get('front')?.value){
        if(!this.insuranceForm.get('card_holder')?.value){
          this.toastrService.error("Please enter Card holder name.");
          return;
        }
        if(!this.insuranceForm.get('contract_plan_number')?.value){
          this.toastrService.error("Please enter Contract plan number.");
          return;
        }
      }

      if(!this.insuranceForm.get('back')?.value){
        if(!this.insuranceForm.get('card_holder')?.value){
          this.toastrService.error("Please enter Card holder name.");
          return;
        }
        if(!this.insuranceForm.get('contract_plan_number')?.value){
          this.toastrService.error("Please enter Contract plan number.");
          return;
        }
      }

      const payload = new FormData();
      payload.append('user_id', this.userId);
      payload.append('card_holder', this.insuranceForm.get('card_holder')?.value);
      payload.append('insurance_provider', this.insuranceForm.get('insurance_provider')?.value);
      payload.append('career_number', this.insuranceForm.get('career_number')?.value);
      payload.append('contract_plan_number', this.insuranceForm.get('contract_plan_number')?.value);
      payload.append('memberId', this.insuranceForm.get('memberId')?.value);
      payload.append('front', this.insuranceForm.get('front')?.value);
      payload.append('back', this.insuranceForm.get('back')?.value);
  
      // Call UserService method to add user insurance
      this.manualService.addUserInsurance(payload, {}).subscribe(
        (res: any) => {
          if (res?.success) {
            this.dialogRef.close(true);
            this.toastrService.success(res?.message);
          }
          else{
            this.toastrService.error(res?.message);
            return;
          }
        },
        (error: any) => {
          console.error('Error adding insurance:', error);
          // Handle error
        }
      );
    } else {
      Object.keys(this.insuranceForm.controls).forEach((field) => {
        const control = this.insuranceForm.get(field);
        control.markAsTouched({ onlySelf: true });
      });
    }
  }
}
